namespace RedBullMOBILE360.SalesApp {
    export interface WalletTransferRow {
        FromPartner?: number;
        ToAgent?: number;
        Amount?: number;
        TransDate?: string;
        TransferBy?: number;
        Id?: number;
        PartnerBalanceBefore?: number;
        PartnerBalanceAfter?: number;
        SellerBalanceBefore?: number;
        SellerBalanceAfter?: number;
        TransferType?: number;
        ReferenceNo?: string;
    }

    export namespace WalletTransferRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ReferenceNo';
        export const localTextPrefix = 'SalesApp.WalletTransfer';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            FromPartner = "FromPartner",
            ToAgent = "ToAgent",
            Amount = "Amount",
            TransDate = "TransDate",
            TransferBy = "TransferBy",
            Id = "Id",
            PartnerBalanceBefore = "PartnerBalanceBefore",
            PartnerBalanceAfter = "PartnerBalanceAfter",
            SellerBalanceBefore = "SellerBalanceBefore",
            SellerBalanceAfter = "SellerBalanceAfter",
            TransferType = "TransferType",
            ReferenceNo = "ReferenceNo"
        }
    }
}
